import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent extends BaseComponent implements OnInit {

  @Input() layout: number = 0;
  @Input() label: string = "";
  @Input() subtitle: string = "";
  @Input() checked: boolean = false;
  @Input() enabled: boolean = true;
  @Output() onChange = new EventEmitter<boolean>();

  valueSetProgrammatically: boolean = false;

  constructor(
  ) {
    super();
  }

  ngOnInit() {
  }

  toggle() {

    if(!this.valueSetProgrammatically) {
      this.onChange.emit(this.checked);
    }
    this.valueSetProgrammatically = false;
  }

  setValue(checked: boolean) {
    if(checked != this.checked){
      setTimeout(() => {
        this.valueSetProgrammatically = true;
        document.getElementById("input-switch").click();
      }, 500);
    }
  }

}
